import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import "../Assets/WebsiteCss/Navbar.css";
import logo from "../Assets/images/rk_logo.png";
import { FaSquarePhone } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const servicesRef = useRef(null);

  // Close dropdown when clicking outside (only on mobile)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (window.innerWidth <= 968) {
        if (servicesRef.current && !servicesRef.current.contains(e.target)) {
          setServicesOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Lock body scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  const closeMenus = () => {
    setMenuOpen(false);
    setServicesOpen(false);
  };

  const toggleServices = () => {
    // Only toggle on mobile
    if (window.innerWidth <= 968) {
      setServicesOpen(!servicesOpen);
    }
  };

  const handleServicesHover = (isHovering) => {
    // Only work on desktop
    if (window.innerWidth > 968) {
      setServicesOpen(isHovering);
    }
  };

  const languages = [
    { code: "en", label: "English" },
    { code: "mr", label: "Marathi" },
    { code: "hi", label: "Hindi" },
  ];

  // Language change handler
  const handleLanguageChange = (e) => {
    const lang = e.target.value;
    // Google Translate uses a select with class 'goog-te-combo'
    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = lang;
      combo.dispatchEvent(new Event("change"));
    }
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* LOGO */}
        <NavLink to="/" className="logo" onClick={closeMenus}>
          <img src={logo} alt="RK Constructions Logo" className="logo-image" />
          
        </NavLink>

        {/* NAV MENU */}
        <nav className={`nav-menu ${menuOpen ? "active" : ""}`}>
          <NavLink to="/" className="nav-link" onClick={closeMenus}>
            Home
          </NavLink>

          <NavLink to="/about-us" className="nav-link" onClick={closeMenus}>
            About Us
          </NavLink>

          {/* SERVICES DROPDOWN */}
          <div
            className="nav-dropdown"
            ref={servicesRef}
            onMouseEnter={() => handleServicesHover(true)}
            onMouseLeave={() => handleServicesHover(false)}
          >
            <button
              className="rk-dropdown-toggle"
              type="button"
              tabIndex={0}
              onClick={toggleServices}
              aria-expanded={servicesOpen}
              aria-haspopup="true"
            >
              Services
              <IoIosArrowDown
                className={`dropdown-arrow ${servicesOpen ? "rotate" : ""}`}
              />
            </button>

            {servicesOpen && (
              <div className="nav-dropdown-menu">
                <NavLink to="/services/planning" onClick={closeMenus}>
                  Building Planning and 3D Design
                </NavLink>
                <NavLink to="/services/construction" onClick={closeMenus}>
                  Construction
                </NavLink>
                <NavLink to="/services/interior" onClick={closeMenus}>
                  Interior and Steel Designing
                </NavLink>
                <NavLink to="/services/construction" onClick={closeMenus}>
                  Estimating, Costing and Supervision
                </NavLink>
              </div>
            )}
          </div>

          <NavLink to="/projects" className="nav-link" onClick={closeMenus}>
            Our Work/Projects
          </NavLink>

          <NavLink to="/contact" className="nav-link" onClick={closeMenus}>
            Contact Us
          </NavLink>
        </nav>

        {/* CONTACT */}
        <div className="header-contact">
          <a href="tel:+917350135259" className="phone-number">
            <FaSquarePhone /> +91 7350135259
          </a>
          {/* Language Dropdown */}
          {/* <select
            className="navbar-language-select"
            defaultValue="en"
            onChange={handleLanguageChange}
            aria-label="Select language"
            style={{ marginLeft: "1rem", padding: "0.25rem 0.5rem", borderRadius: 4 }}
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.label}
              </option>
            ))}
          </select> */}
        </div>

        {/* HAMBURGER */}
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </header>
  );
}

export default Navbar;
